import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import { ImageResponse, SeriesBadge } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';

type ImageAssetSize = 'thumbnail' | 'large' | 'xLarge' | 'original';

type ImageState = 'loading' | 'loaded' | 'error';

export type ImageAspect = 'landscape' | 'landscape_fill' | 'portrait' | 'square' | 'banner' | 'banner_thin';


export default /*#__PURE__*/_defineComponent({
  __name: 'TG4Image',
  props: {
    image: null,
    aspect: { default: 'landscape' },
    size: { default: 'large' },
    badge: { default: null },
    alt: { default: '' }
  },
  setup(__props: any) {

const props = __props as { image: ImageResponse | null, aspect: ImageAspect, size: ImageAssetSize, badge: SeriesBadge | null, alt: string };



const LARGE_FALLBACK_ABOVE = 400;



const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const rootRef = ref<HTMLElement | null>(null);
const loadState = ref<ImageState>('loading');
const largeFallback = ref(false);

const imageUrl = computed(() => props.image?.[props.size] ?? null);

const state = computed<ImageState>(() => (imageUrl.value ? loadState.value : 'error'));

const badgeKey = computed(() => `badge.${props.badge}`);

const altText = computed(() => {
  const img = props.image;
  if (!img) return props.alt;
  const localised = currentLanguage.value === Language.Irish ? img.altTextGa : img.altTextEn;
  return localised ?? img.altTextEn ?? props.alt;
});

const onLoad = () => {
  loadState.value = 'loaded';
};

const onError = () => {
  //Measure width to pick error image
  const width = rootRef.value?.clientWidth ?? 0;
  largeFallback.value = width > LARGE_FALLBACK_ABOVE;
  loadState.value = 'error';
};


watch(imageUrl, () => {
  loadState.value = 'loading';
  largeFallback.value = false;
});

return { __sfc: true,LARGE_FALLBACK_ABOVE, props, useGetter, currentLanguage, rootRef, loadState, largeFallback, imageUrl, state, badgeKey, altText, onLoad, onError }
}

})